const otpIdentityVerificationTemplate = `
<pwr-otp-identity-verification-component 
    options="ctrl.options"
    flow-state="ctrl.flowState"
></pwr-otp-identity-verification-component>
`;
export default otpIdentityVerificationTemplate;